import { PaginationBar } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  pageChangeCallback,
  pageSizeChangeCallback
} from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import { paginationState } from 'Pages/WorkflowsList/recoil/state/search'

const Pagination = () => {
  const intl = useIntl()

  const { pageNumber, pageSize, totalItems } = useRecoilValue(paginationState)

  const handleChangePage = useRecoilCallback(pageChangeCallback)
  const handleChangePageSize = useRecoilCallback(pageSizeChangeCallback)

  return (
    <PaginationBar
      data-mu-test='pager'
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
      handleChangePage={handleChangePage}
      handleChangePageSize={handleChangePageSize}
    />
  )
}

export default Pagination
